import React, { memo } from 'react';
import { Button } from '@mui/material';
import styles from './adminconfigurationdetails.module.scss';

import AdminMealtimeCharacteristicsTable from '../../../components/commonComponent/AdminConfigurationTableWrap/AdminMealtimeCharacteristicsTable';
import SingleSelect from '../../../components/commonComponent/SingleSelect';
import AdminMenuProjectionTable from '../../../components/commonComponent/AdminConfigurationTableWrap/AdminMenuProjectionTable';
import AdminMenuRequisitionTable from '../../../components/commonComponent/AdminConfigurationTableWrap/AdminMenuRequisitionTable';
import useAdminConfiguration from './useAdminConfigurtion';
import Loader from '../../../components/loader/Loader';

const AdminConfigurationDetails: React.FC = () => {
  const {
    values,
    loading,
    isPublishButtonDisabled,
    handleChangeOthers,
    mealtime,
    menuProjectionData,
    menuRequisitionData,
    exceptionalMenuRequisitionData,
    handleSwitchChange,
    handleMenuProjection,
    handleMenuRequisition,
    handleExceptionalMenuRecognition,
    kitchenIntentData,
    handleKitchenIntendent,
    handleSubmit,
    updateproductionplanmodel,
    handleUpdateproductionplanmodel,
    siteDisplayOptions,
    selectedDisplayItemWiseId,
    handleSiteDisplayChange,
  } = useAdminConfiguration();

  // Memoize options to prevent recreation on every render
  const singleSelectOptions = React.useMemo(() => {
    return [
      { value: 0, label: 'Select' },
      ...(siteDisplayOptions?.map(o => ({ 
        value: o.itemdisplaymasterid, 
        label: o.itemdisplayname 
      })) || [])
    ];
  }, [siteDisplayOptions]);

  return (
    <>
      <div className="white-box mb-12">
        <div className="flex justify-content-end mb-8">
          <div className="button-wrap flex align-items-center">
            <Button
              className="primary-btn btn-right ml-16"
              disabled={isPublishButtonDisabled}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </div>

        <div className="inner-contant kitchen-dashboard">
          {/* Initiate Menu Plan */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Initiate Menu Plan</div>
            <div className={`flex justify-content-between align-items-center ${styles.box}`}>
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Menu Plan (in Months)
              </div>
              <div className="flex align-items-center">
                <input
                  className={styles.input}
                  type="number"
                  value={values.reviewtimeperiodmonths ?? ''}
                  name="reviewtimeperiodmonths"
                  onChange={handleChangeOthers}
                />
                <span className={styles.text}>Months</span>
              </div>
            </div>
          </div>

          {/* Mealtime Characteristics */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Mealtime Characteristics</div>
            <AdminMealtimeCharacteristicsTable
              data={mealtime}
              handleSwitchChange={handleSwitchChange}
            />
          </div>

          {/* Menu Projection */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Menu Projection </div>
              <div
              className={`flex justify-content-between align-items-center mb-10 ${styles.box}`}
            >
              
              <div className={styles.boxTitle}>
                MR & MP Item-wise Display Configuration
              </div>
              <div className="flex align-items-center" style={{ minWidth: '150px' }}>
                <SingleSelect
                  label=""
                  options={singleSelectOptions}
                  value={selectedDisplayItemWiseId ?? 0}
                  onChange={handleSiteDisplayChange}
                  placeholder="Select"
                />
              </div>
            </div>
            <div
              className={`flex justify-content-between align-items-center mb-10 ${styles.box}`}
            >
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Menu Projections (in Months)
              </div>
              <div className="flex align-items-center">
                <input
                  type="text"
                  className={styles.input}
                  value={values.pastmonthprojection ?? ''}
                  name="pastmonthprojection"
                  onChange={handleChangeOthers}
                />               
              </div>
            </div>

            <div className={`mb-10 ${styles.box}`}>
              <div className={styles.innerTitle}>
                Quantity tolerance limit compared with how many days
              </div>
              <div className="flex justify-content-between align-items-center">
                <div
                  className={`flex align-items-center justify-content-between ${styles.innerbox}`}
                >
                  <div className={styles.label}>
                    Tolerance limit (%) <span className={styles.require}>*</span>
                  </div>
                  <div className="flex align-items-center">
                    <input
                      type="text"
                      className={styles.input}
                      value={values.projectionquantitytolerancepercentage ?? ''}
                      name="projectionquantitytolerancepercentage"
                      onChange={handleChangeOthers}
                    />
                    <span className={styles.text}>%</span>
                  </div>
                </div>
                <div
                  className={`flex align-items-center justify-content-between ${styles.innerbox}`}
                >
                  <div className={styles.label}>
                    Compare with days <span className={styles.require}>*</span>
                  </div>
                  <div className="flex align-items-center">
                    <input
                      type="text"
                      className={styles.input}
                      value={values.projectioncomparedays ?? ''}
                      name="projectioncomparedays"
                      onChange={handleChangeOthers}
                    />
                    <span className={styles.text}>Days</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.tableTopBox}>
              <div className={styles.tableTitle}>
                Define Weeks/Months before for doing Menu Projection, Cut-Off Time, and Alert Email
              </div>
            </div>
            <AdminMenuProjectionTable
              data={menuProjectionData}
              handleMenuProjection={handleMenuProjection}
            />
          </div>



          {/* Menu Requisition */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Menu Requisition</div>
            <div
              className={`flex justify-content-between align-items-center mb-10 ${styles.box}`}
            >
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Menu Requisition (in Months)
              </div>
              <div className="flex align-items-center">
                <input
                  type="text"
                  className={styles.input}
                  value={values.pastmonthrequisition ?? ''}
                  name="pastmonthrequisition"
                  onChange={handleChangeOthers}
                />
                <span className={styles.text}>Months</span>
              </div>
            </div>

            <div className={`mb-10 ${styles.box}`}>
              <div className={styles.innerTitle}>
                Quantity tolerance limit compared with how many days
              </div>
              <div className="flex justify-content-between align-items-center">
                <div
                  className={`flex align-items-center justify-content-between ${styles.innerbox}`}
                >
                  <div className={styles.label}>
                    Tolerance limit (%) <span className={styles.require}>*</span>
                  </div>
                  <div className="flex align-items-center">
                    <input
                      type="text"
                      className={styles.input}
                      value={values.requisitionquantitytolerancepercentage ?? ''}
                      name="requisitionquantitytolerancepercentage"
                      onChange={handleChangeOthers}
                    />
                    <span className={styles.text}>%</span>
                  </div>
                </div>
                <div
                  className={`flex align-items-center justify-content-between ${styles.innerbox}`}
                >
                  <div className={styles.label}>
                    Compare with days <span className={styles.require}>*</span>
                  </div>
                  <div className="flex align-items-center">
                    <input
                      type="text"
                      className={styles.input}
                      value={values.requisitioncomparedays ?? ''}
                      name="requisitioncomparedays"
                      onChange={handleChangeOthers}
                    />
                    <span className={styles.text}>Days</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.tableTopBox}>
              <div className={styles.tableTitle}>
                Define Days before for doing Menu Requisition, Cut-Off Time, and Alert Email
              </div>
            </div>
            <AdminMenuRequisitionTable
              data={menuRequisitionData}
              handleMenuRequisition={handleMenuRequisition}
              modulename={'MR'}
            />
          </div>

          {/* Exceptional Menu Requisition */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Exceptional Menu Requisition</div>
            <div
              className={`flex justify-content-between align-items-center mb-10 ${styles.box}`}
            >
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Menu Requisition (in Months)
              </div>
              <div className="flex align-items-center">
                <input
                  type="text"
                  className={styles.input}
                  value={values.pastmonthexceptionalrequisition ?? ''}
                  name="pastmonthexceptionalrequisition"
                  onChange={handleChangeOthers}
                />
                <span className={styles.text}>Months</span>
              </div>
            </div>


            <div className={styles.tableTopBox}>
              <div className={styles.tableTitle}>
                Define Days before for doing Exceptional Menu Requisition, Cut-Off Time, and Alert
                Email
              </div>
            </div>
            <AdminMenuRequisitionTable
              data={exceptionalMenuRequisitionData}
              handleMenuRequisition={handleExceptionalMenuRecognition}
              modulename={'EMR'}
            />
          </div>

          {/* Kitchen Intent */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Kitchen Indent</div>
            <AdminMenuRequisitionTable
              data={kitchenIntentData}
              handleMenuRequisition={handleKitchenIntendent}
              modulename={'KI'}
            />
          </div>

          {/* Upgrade Production */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Update Production Plan</div>
            <AdminMenuRequisitionTable
              data={updateproductionplanmodel}
              handleMenuRequisition={handleUpdateproductionplanmodel}
              modulename={'UPP'}
            />
          </div>

          {/* Menu Projection Dashboard */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Menu Projection Dashboard</div>
            <div className={`flex justify-content-between align-items-center ${styles.box}`}>
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Menu Projection Dashboard (in
                Months)
              </div>
              <div className="flex align-items-center">
                <input
                  type="text"
                  className={styles.input}
                  value={values.pastmonthprojectiondashboard ?? ''}
                  name="pastmonthprojectiondashboard"
                  onChange={handleChangeOthers}
                />
                <span className={styles.text}>Months</span>
              </div>
            </div>
          </div>

          {/* Kitchen Dashboard */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Kitchen Dashboard</div>
            <div className={`flex justify-content-between align-items-center ${styles.box}`}>
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Kitchen Dashboard (in Months)
              </div>
              <div className="flex align-items-center">
                <input
                  type="text"
                  className={styles.input}
                  value={values.pastmonthkitchendashboard ?? ''}
                  name="pastmonthkitchendashboard"
                  onChange={handleChangeOthers}
                />
                <span className={styles.text}>Months</span>
              </div>
            </div>
          </div>

          {/* Site Manager Dashboard */}
          <div className="innrBox innerbox-shadow">
            <div className={styles.title}>Site Manager Dashboard</div>
            <div className={`flex justify-content-between align-items-center ${styles.box}`}>
              <div className={styles.boxTitle}>
                Define time-period for viewing the past/ previous Site Manager Dashboard (in Months)
              </div>
              <div className="flex align-items-center">
                <input
                  type="text"
                  className={styles.input}
                  value={values.pastmonthsitemanagerdashboard ?? ''}
                  name="pastmonthsitemanagerdashboard"
                  onChange={handleChangeOthers}
                />
                <span className={styles.text}>Months</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && <Loader />}
    </>
  );
};

export default memo(AdminConfigurationDetails);
